import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Button } from "../../Button";
import {
  DealStatus_Enum,
  GetDealDocument,
  UpdateDealStatusDocument,
} from "../../../generated/graphql-operations";

export const CompleteDealButton = ({
  dealStatus,
  dealId,
}: {
  dealStatus: DealStatus_Enum;
  dealId: number;
}) => {
  const [updateDealStatus] = useMutation(UpdateDealStatusDocument);
  const [currentStatus, setCurrentStatus] = useState(dealStatus);

  const handleButtonClick = async () => {
    const newStatus =
      currentStatus === DealStatus_Enum.Completed
        ? DealStatus_Enum.Approved
        : DealStatus_Enum.Completed;

    await updateDealStatus({
      variables: { dealId, status: newStatus },
      refetchQueries: [GetDealDocument],
    });

    setCurrentStatus(newStatus);
  };

  // Have to also handle going back from completed to lease executed
  return (
    <Button variant="contained" onClick={handleButtonClick}>
      {currentStatus === DealStatus_Enum.Completed
        ? "Mark as Incomplete"
        : "Complete Deal"}
    </Button>
  );
};
